<template>
  <div id="Security_partners">Security_partners</div>
</template>

<script>
export default {
  name: "Security_partners",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
